import DonateDifferentAmount from './DonateDifferentAmount';

export default DonateDifferentAmount;
